module.exports = __webpack_public_path__ + "static/staff-john-9ade4d6ecc93693a2278584ff55c1c4d.png";